<script lang="ts">
	import { Button } from "@ishavskraft/shared";
	import { Picture } from "@ishavskraft/shared";
	import type { AvtaleInteractiveModule } from "#lib/types/avtale.js";
	import { PortableText } from "@portabletext/svelte";

	interface Props {
		module: AvtaleInteractiveModule;
	}

	let { module }: Props = $props();
</script>

<div class="mx-edge-x flex flex-col-reverse tablet:flex-row gap-4 mb-8 tablet:mb-11">
	<div class="basis-1/2 flex flex-col">
		<h2>{module.title}</h2>
		<PortableText value={module.interactive_module_content} />
		{#if module.interactive_module_button}
			<div class="mt-auto">
				<Button primary href={module.interactive_module_button_link}
					>{module.interactive_module_button_text}</Button
				>
			</div>
		{/if}
	</div>
	<div class="basis-1/2">
		{#if module.sub_image && module.sub_image.src}
			<Picture
				src={module.sub_image.src}
				srcset={module.sub_image.srcset}
				srcsetWebp={module.sub_image.srcsetWebp}
				alt={module.sub_image.alt}
				class="object-cover w-full h-full rounded-xl"
			/>
		{/if}
	</div>
</div>
